import Api from '@/services/Api'

export default class AppService {
  apiTester() {
    return Api().get(`/v2/api-tester`)
  }
  getRequest(url) {
    return Api().get(url)
  }
  postRequest(url, data) {
    let formData
    if (data) {
      formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
    }
    return Api().post(url, formData)
  }
}
